export default __webpack_public_path__ + "static/media/Gallery-White-Icon.21b9d98c.svg";